const messages = {
  title: "Prodajne promocije",
  desc: "Aktivno koristite naše prodajne promocije s vašim klijentima. Naravno, možete ponuditi klijentima obje promocije. Pročitajte više o Garanciji guma i Drive Our Best u nastavku.",
  participation: {
    title: "Zatražite vaše sudjelovanje sada",
    desc: "Biste li željeli implementirati jednu ili više naših promocija u vašoj trgovini? Tada možete zatražiti ovdje vaše sudjelovanje. Vaša tvrtka će biti aktivirana za promocije i primit će promotivne materijale u roku od 4 tjedna za vašu prodajnu kampanju.<br/><br/>Napravite vaš izbor:",
    request: "ZATRAŽI SUDJELOVANJE",
    success: "Hvala vam, vaš zahtjev je poslan",
  },
};
export default {
  messages,
};
